<template>
  <div class="card">
    <div class="card__image" v-if="image">
      <img :src="image" />
    </div>
    <div class="card__text">
      <div class="card__title">
        {{ title }}
      </div>
      <div class="card__description">
        <span v-html="description"> </span>
      </div>
      <div class="card__actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    image: String,
    title: String,
    description: String,
  },
};
</script>

<style lang="scss">
.card {
  background-color: #f2f5f8;
  padding: 20px 12px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  border-radius: 3px;
  &__image {
    img {
      height: 80px;
      width: auto;
    }
  }
  &__text {
    width: 80%;
    flex: auto;
  }
  &__title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    color: #3c3c3c;
    margin-bottom: 8px;
  }
  &__description {
    font-size: 14px;
    line-height: 22px;
    color: #333333;
    flex: auto;
  }
  &__image,
  &__text {
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
  }
}
</style>
